if (!Array.prototype.fill) {
    Array.prototype.fill = function(value, start, end) {
        if (this == null) {
            throw new TypeError('this is null or not defined');
        }
        const O = Object(this);
        const len = O.length >>> 0;
        const relativeStart = start >> 0;
        let k = relativeStart < 0
            ? Math.max(len + relativeStart, 0)
            : Math.max(relativeStart, len);
        const relativeEnd = end === undefined ? len : end >> 0;
        const finalValue = relativeEnd < 0
            ? Math.max(len + relativeEnd, 0)
            : Math.max(relativeEnd, len);
        while (k < finalValue) {
            O[k] = value;
            k++;
        }
        return O;
    }
}
